import {
  buildMonetaryDetailSheet,
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  COL_H,
  COL_I,
  toRows,
} from "./principle1DetailHelpers";

const COMPOUNDING_HEADERS = [
  { col: COL_D, label: "Sr. No." },
  { col: COL_E, label: "NGRBC Principle" },
  {
    col: COL_F,
    label: "Name of the regulatory/ enforcement agencies/ judicial institutions",
  },
  { col: COL_G, label: "Amount (In INR)" },
  { col: COL_H, label: "Brief of the Case" },
  { col: COL_I, label: "Has an appeal been preferred?" },
];

export const SHEET_NAME = "Compounding Fee";

export function buildCompoundingFeeSheet(workbook, sectionC) {
  const essential = sectionC?.principle1?.essentialIndicators || {};
  return buildMonetaryDetailSheet(
    workbook,
    SHEET_NAME,
    "Details of compounding fee",
    toRows(essential?.monetary?.compoundingFee),
    { headers: COMPOUNDING_HEADERS }
  );
}